<template>
  <div>
    <div v-if="isMobile">
      <app-request v-for="index in history.length" :key="index" :history="history[index - 1]"
        @removeRequest="removeRequest">
      </app-request>
    </div>
    <div v-else>
      <v-data-table :items="history" :headers="historyHeaders" class="elevation-1 rounded" :disable-pagination="true"
        :hide-default-footer="true" :no-data-text="tableText" show-expand item-key="Fserial">
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>تاریخ شروع تبلیغ:</b>
            <span v-html="item.D_StartEzam"></span>


            <br />
            <br />
            <b>تاریخ پایان تبلیغ: </b>
            <span v-html="item.D_EndEzam"></span>


            <br />
            <br />
            <b>ملاحظات طلبه:</b>
            <br />
            <span v-html="item.Des_Fard"></span>

            <br />
            <br />

            <b>نظر ستاد تبلیغ: </b>
            <span v-html="item.Des_Setad"></span>
            <br />
            <br />
          </td>
        </template>
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn class="grid" v-if="item.IsRemovable" color="red white--text" rounded @click="removeRequest(item)">
            حذف درخواست
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import EzamRequest from "./EzamRequest";
import { getEzamRequestHistory, CancelRequest } from "@/api/ezamrequest";
import Dialog from "@/components/Dialog";

export default {
  components: {
    appRequest: EzamRequest,
    appDialog: Dialog,
  },
  data() {
    return {
      historyHeaders: [
        {
          text: "نام طرح",
          value: "TarhName",
        },
        {
          text: "شهر محل تبلیغ",
          value: "FullAddress",
        },
        {
          text: "آدرس محل تبلیغ",
          value: "MahaleEzam",
        },
        { text: "توضیحات", value: "data-table-expand" },
        { text: "", value: "Removable" },
      ],
      history: [],
    };
  },
  created() {
    this.getHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },

  methods: {
    convertStateToString(state) {
      return state === true ? "تایید" : "";
    },
    getHistory() {
      return new Promise((resolve, reject) => {
        getEzamRequestHistory()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.history = response.data;
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index.Fserial);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        CancelRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.getHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
